import { http } from '@/utils/api'
import { withPbx } from '@/stores/network/api'
import * as Sentry from '@/core/sentry'
import { isWhitelistError } from '@/utils/api/whitelist'

export async function loadFeatures() {
  try {
    const url = withPbx(`features`)

    const { data } = await http.get<string[]>(url)

    return {
      status: 'success' as const,
      payload: data,
    }
  } catch (error) {
    if (!isWhitelistError(error)) {
      Sentry.captureException(error)
    }

    return {
      status: 'error' as const,
      payload: error,
    }
  }
}
